import { makeStateStore } from '@playcastdotio/StateStore';
import type { PlaycastChannels, PlaycastDefaultProfiles } from '@playcastdotio/CoreTypes';

export type PlaycastSendProfile = PlaycastChannels[];

function createDefaultProfiles<T extends { [key: string]: PlaycastChannels[] }>(profiles: T): T {
  return profiles;
}

const defaultProfiles = createDefaultProfiles({
  default: ['default', 'hostCamera', 'hostDesktopAudio', 'hostMicrophone', 'hostShadowCam03Video', 'hostShadowCam04Video'],
  remoteClient: [
    'default',
    'remoteHostVideo',
    'remoteHostAudio',
    'remoteHostMicrophone',
    'hostShadowCam03Video',
    'hostShadowCam04Video',
    'hostCamera',
    'hostDesktopAudio',
    'hostMicrophone',
  ],
  hostHigh: ['default', 'hostCamera', 'hostDesktopAudio', 'hostMicrophone', 'hostShadowCam03Video', 'hostShadowCam04Video'],
  hostMedium: [
    'default',
    'hostCamera',
    'hostDesktopAudio',
    'hostMicrophone',
    'hostShadowCam03Video',
    'hostShadowCam04Video',
  ],
  hostLow: [
    'default',
    'hostCamera',
    'hostDesktopAudio',
    'hostMicrophone',
    'hostShadowCam03Video',
    // 'hostShadowCam00Video',
    'hostShadowCam04Video',
  ],
});
const profiles = makeStateStore<{ [name: string]: PlaycastSendProfile }>(defaultProfiles);

export const getProfile = (profileName: PlaycastDefaultProfiles): PlaycastSendProfile => {
  return profiles.currentState[profileName];
};

export const addProfile = (profileName: string, profile: PlaycastSendProfile) => {
  profiles.updateState({ ...profiles.currentState, [profileName]: profile });
};
